import Seo from '../components/Seo';
import { breadcrumb } from '../lib/seo-schemas';

const PHOTOS = [
  { src: '/dishes/gilda-clasica.jpg',  alt: 'Gilda Clásica — anchoa de Santoña, oliva manzanilla y piparra verde',           cap: 'La Clásica · anchoa, oliva, piparra', tall: true },
  { src: '/dishes/gilda-pulpo.jpg',    alt: 'Gilda de Pulpo — pulpo, anchoa, piparra, huevo de codorniz y pimentón',         cap: 'La de Pulpo · la más generosa' },
  { src: '/dishes/gilda-iberica.jpg',  alt: 'Gilda Ibérica — anchoa, piparra, queso manchego, cecina ibérica y tomate seco', cap: 'La Ibérica · producto peninsular' },
  { src: '/dishes/gilda-langostino.jpg', alt: 'Gilda de Langostino — langostino, huevo, pimiento, oliva y mayonesa',         cap: 'La de Langostino · marinera' },
  { src: '/dishes/gilda-verde.jpg',    alt: 'Gilda Verde — aceituna, piparra, cebollita y tomate seco',                       cap: 'La Verde · la más fresca, sin pescado', tall: true },
  { src: '/dishes/gilda-picante.jpg',  alt: 'Gilda Picante — anchoa, piparra, aceituna y guindilla riojana',                  cap: 'La Picante · para los valientes' },
  { src: '/dishes/tortilla.jpg',       alt: 'Tortilla española casera del Bar Cabrero',                                       cap: 'Tortilla casera, cuajada al gusto' },
  { src: '/dishes/bar-vermut.jpg',     alt: 'Copa de vermut rojo con naranja y oliva',                                        cap: 'Vermut de grifo, los domingos' },
  { src: '/dishes/bar-canapes.jpg',    alt: 'Canapés tradicionales del Bar Cabrero — anchoa, gambas, bonito',                cap: 'Canapés caseros' },
];

export default function Galeria() {
  return (
    <>
      <Seo
        title="Galería"
        description="Galería del Bar Cabrero en Torrelavega — interior de la taberna, gildas artesanas, tortilla casera, vermut del domingo y la barra más alta de Cantabria."
        path="/galeria"
        schemas={[breadcrumb([{ name: 'Galería', path: '/galeria' }])]}
      />
      <section className="sec sec-surf" data-testid="galeria-page">
        <p className="eyebrow rv">Galería</p>
        <h1 className="D D-xl rv" style={{ marginBottom: '1rem' }}>
          El Cabrero, <em>en imágenes.</em>
        </h1>
        <p className="lead rv">
          La barra alta, las gildas, el vermut del domingo y el mus de los amigos. Casi un siglo de aperitivo en Torrelavega.
        </p>
      </section>

      <section className="sec" data-testid="galeria-grid-section">
        <div className="gal-grid" data-testid="galeria-grid">
          {PHOTOS.map((p, i) => (
            <figure
              key={p.src}
              className={`gal-item rv ${p.tall ? 'tall' : ''}`}
              data-testid={`galeria-item-${i + 1}`}
            >
              <img src={p.src} alt={p.alt} loading="lazy" />
              <figcaption className="gal-cap">{p.cap}</figcaption>
            </figure>
          ))}
        </div>
        <p className="copy rv" style={{ textAlign: 'center', marginTop: '2.5rem', fontStyle: 'italic' }}>
          ¿Tienes fotos del Cabrero? Etiqueta a <a href="https://instagram.com/cabrerobar" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--verde)' }}>@cabrerobar</a> en Instagram.
        </p>
      </section>
    </>
  );
}
